import { StepsEnum } from '@websky/core/src/types';
import { CardType } from '@websky/core/src/PromoLoader/types';
import i18next from 'i18next';
import { Currency, CurrencySymbols } from '@websky/core/src/enums';
import { getLocale } from '@websky/core/src/utils';
import { BaggageType } from '@websky/graphql';
let currentLocale = getLocale();
const localeLangMap = new Map([['kk', 'kz']]);
currentLocale = localeLangMap.has(currentLocale) ? localeLangMap.get(currentLocale) : currentLocale;
const isProd = process.env.NODE_ENV === 'production';
const companyInfo = {
    iataCode: 'JI',
    privacyPolicy: `https://armenianairlines.am/${currentLocale}/legal/privacy-policy`,
    exareRulesURL: '',
    exarePrivacyPolicyURL: `https://armenianairlines.am/${currentLocale}/legal/privacy-policy`,
    subsidyFaresConditionURL: ''
};
export const i18n = {
    en: {
        LoginPage: {
            'Email / Phone / Card number': 'Email'
        },
        AddPassenger: {
            Find: 'Add'
        },
        Title: {
            companyName: 'Armenian Airlines'
        },
        Checkout: {
            'passenger transportation': 'passengers',
            'baggage transportation': 'baggage transportation conditions'
        }
    },
    ru: {
        LoginPage: {
            'Email / Phone / Card number': 'Эл. почта'
        },
        AddPassenger: {
            Find: 'Добавить'
        },
        Exchange: {
            'Privacy Policy': 'условиями обработки персональных данных'
        },
        Refund: {
            'Privacy Policy': 'условиями обработки персональных данных'
        },
        Title: {
            companyName: 'Armenian Airlines'
        },
        Checkout: {
            'passenger transportation': 'условиями перевозки пассажиров',
            'baggage transportation': 'багажа'
        }
    },
    de: {
        Title: {
            companyName: 'Armenian Airlines'
        }
    },
    fr: {
        Title: {
            companyName: 'Armenian Airlines'
        }
    },
    hy: {
        Title: {
            companyName: 'Armenian Airlines'
        },
        Checkout: {
            'I accept the': 'համաձայն եմ',
            'terms of tariff': 'սակագնի կիրառման',
            'passenger transportation': 'ուղևորափոխադրման',
            'baggage transportation': 'բեռնա',
            'processing of my personal data': 'անձնական տվյալների մշակման պայմանների հետ'
        },
        FlightPrice: {
            '{{count}} {{ticket}} {{left}}': '{{count}} {{ticket}} {{left}}'
        }
    },
    ka: {
        Title: {
            companyName: 'Armenian Airlines'
        }
    },
    kk: {
        Title: {
            companyName: 'Armenian Airlines'
        }
    },
    zh: {
        Title: {
            companyName: 'Armenian Airlines'
        }
    }
};
export const promoLoaders = [
    {
        type: CardType.City,
        city: '',
        title: '',
        text: '',
        image: 'https://cdn.websky.aero/content/frontend/images/JI-LoadingBanners/1.png'
    },
    {
        type: CardType.City,
        city: '',
        title: '',
        text: '',
        image: 'https://cdn.websky.aero/content/frontend/images/JI-LoadingBanners/2.png'
    },
    {
        type: CardType.City,
        city: '',
        title: '',
        text: '',
        image: 'https://cdn.websky.aero/content/frontend/images/JI-LoadingBanners/3.png'
    },
    {
        type: CardType.City,
        city: '',
        title: '',
        text: '',
        image: 'https://cdn.websky.aero/content/frontend/images/JI-LoadingBanners/4.png'
    }
];
const defaultSteps = {
    [StepsEnum.Flights]: {
        label: i18next.t('Stepbar:Flights')
    },
    [StepsEnum.Passengers]: {
        label: i18next.t('Stepbar:Passengers')
    },
    [StepsEnum.Order]: {
        label: i18next.t('Stepbar:Order')
    },
    [StepsEnum.Payment]: {
        label: i18next.t('Stepbar:Payment')
    }
};
const baggageConfig = {
    baggageLimit: {
        baggageByTypeLimit: [
            {
                baggageType: BaggageType.CheckedBaggage,
                maxBaggagePerPassenger: 3
            }
        ]
    }
};
export const config = {
    global: {
        yandexMetrikaId: isProd ? '93216324' : undefined,
        gtmId: isProd ? 'GTM-K5N57X6' : undefined,
        companyInfo,
        maxBaggagePerPassenger: 3,
        baggage: baggageConfig,
        showIsActualizationResultOk: false,
        stepsAvailable: {
            [StepsEnum.Meal]: false
        },
        findOrderURL: '',
        i18n,
        authMethods: {
            email: true
        },
        reserveEngines: {
            siteUrl: `https://armenianairlines.am/${currentLocale}`
        }
    },
    Account: {
        engineURL: './booking',
        showUserPhoneInput: false
    },
    Engine: {
        calendarDaysCount: 5,
        searchFormURL: isProd ? './' : null,
        checkInURL: './check-in',
        checkInEnabled: true,
        showAvailableFaresOnly: true,
        promoLoaders,
        defaultSteps
    },
    SearchForm: {
        payByMiles: false,
        showPricesInDatepicker: true,
        selectableCurrencies: [
            {
                code: Currency.AMD,
                symbol: CurrencySymbols.AMD
            },
            {
                code: Currency.RUB,
                symbol: CurrencySymbols.RUB
            }
        ]
    },
    FlightStatus: {
        playMarketURL: '',
        appStoreURL: ''
    }
};
